// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ERdz","footer":"ModalCreateQualiphyProcedure_footer__8N4Ag","additionData":"ModalCreateQualiphyProcedure_additionData__3Y5Ef"};